import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tendré que darle mis contraseñas a mis hijos ahora?',
    a: 'No. El método te enseña cómo darles acceso futuro sin comprometer tu privacidad hoy.'
  }, {
    q: '¿Es difícil de configurar?',
    a: 'Si sabes usar WhatsApp, puedes seguir esta guía. Está diseñada para personas que no crecieron con la tecnología.'
  }, {
    q: '¿Sirve para cuentas fuera de USA?',
    a: 'Sí, los protocolos de Apple, Google y Facebook son globales.'
  }, {
    q: '¿Qué pasa si cambio de celular?',
    a: 'La guía incluye una sección de mantenimiento de 10 minutos para actualizar tu legado anualmente.'
  }, {
    q: '¿Es un servicio de suscripción?',
    a: 'No, es un pago único por el conocimiento y las plantillas que te servirán de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream section-padding" data-id="element-53">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-54">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-55">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-200" data-id="element-56">
            <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-57">
              <span className="text-lg font-bold text-navy-dark pr-8" data-id="element-58">
                {faq.q}
              </span>
              {openIndex === index ? <ChevronUp className="w-6 h-6 text-gold flex-shrink-0" data-id="element-59" /> : <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-60" />}
            </button>

            <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-61">
              <p className="text-gray-600 text-lg" data-id="element-62">{faq.a}</p>
            </div>
          </div>)}
      </div>
    </section>;
}